var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87504 12.5C9.1187 12.5 10.9375 10.6812 10.9375 8.43751C10.9375 6.19385 9.1187 4.375 6.87504 4.375C4.63138 4.375 2.81253 6.19385 2.81253 8.43751C2.81253 10.6812 4.63138 12.5 6.87504 12.5Z",
    stroke: "#00A6FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1416 4.52628C12.7004 4.36885 13.2864 4.33299 13.8602 4.4211C14.434 4.50922 14.9823 4.71928 15.468 5.03713C15.9538 5.35497 16.3658 5.77323 16.6764 6.26372C16.9869 6.75421 17.1887 7.30555 17.2682 7.88061C17.3477 8.45566 17.303 9.04107 17.1372 9.59741C16.9714 10.1538 16.6883 10.6681 16.307 11.1058C15.9257 11.5435 15.455 11.8945 14.9266 12.1349C14.3982 12.3754 13.8245 12.4999 13.2439 12.5",
    stroke: "#00A6FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24973 15.4214C1.88421 14.5189 2.72652 13.7823 3.70555 13.2738C4.68458 12.7653 5.77159 12.4998 6.8748 12.4998C7.97801 12.4997 9.06504 12.7651 10.0441 13.2735C11.0232 13.782 11.8656 14.5185 12.5001 15.4209",
    stroke: "#00A6FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2439 12.4998C14.3472 12.499 15.4345 12.764 16.4137 13.2725C17.3928 13.781 18.235 14.518 18.869 15.421",
    stroke: "#00A6FF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Users.d4843c64.svg";
export { ForwardRef as ReactComponent };